"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BodyCell = exports.BodyCellStyleName = void 0;
var tslib_1 = require("tslib");
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var typestyle_1 = require("typestyle");
var Column_1 = require("./Column");
var DataGridColors_1 = require("./DataGridColors");
var DefaultFormatter_1 = require("./DefaultFormatter");
var Utils_1 = require("./Utils");
exports.BodyCellStyleName = typestyle_1.style({
    boxSizing: 'border-box',
    display: 'inline-block',
    height: 'inherit',
    overflow: 'hidden',
    verticalAlign: 'top',
    $nest: (_a = {
            '&[aria-selected="true"]': { backgroundColor: DataGridColors_1.DataGridColors.Selected }
        },
        _a["[role=\"grid\"]." + DataGridColors_1.VerticalLines + " &"] = {
            borderRight: DataGridColors_1.DataGridLines.VerticalLineWidth + " " + DataGridColors_1.DataGridLines.VerticalLineStyle + " " + DataGridColors_1.DataGridLines.VerticalLineColor,
        },
        _a["[role=\"grid\"]." + DataGridColors_1.VerticalLines + " &[aria-selected=\"true\"]"] = {
            borderRightColor: DataGridColors_1.DataGridColors.SelectedLine,
        },
        _a["[role=\"grid\"]." + DataGridColors_1.VerticalLines + " &:has(+ &[aria-selected=\"true\"])"] = {
            // add a border on the left side of a selection range (via right border on the previous cell)
            borderRightColor: DataGridColors_1.DataGridColors.SelectedLine,
        },
        _a["[role=\"grid\"]." + DataGridColors_1.HorizontalLines + " &"] = {
            borderBottom: DataGridColors_1.DataGridLines.HorizontalLineWidth + " " + DataGridColors_1.DataGridLines.HorizontalLineStyle + " " + DataGridColors_1.DataGridLines.HorizontalLineColor,
        },
        _a["[role=\"grid\"]." + DataGridColors_1.HorizontalLines + " &[aria-selected=\"true\"]"] = {
            borderBottomColor: DataGridColors_1.DataGridColors.SelectedLine,
        },
        _a)
});
var BodyCell = /** @class */ (function (_super) {
    tslib_1.__extends(BodyCell, _super);
    function BodyCell() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.domRef = React.createRef();
        _this.handleClick = function (e) {
            if (e.target !== e.currentTarget && Utils_1.isFocusable(e.target)) {
                // presume that we don't want to trigger a cell handler if an interactive child was clicked
                return;
            }
            var handler = {
                click: _this.props.onCellClick, contextmenu: _this.props.onCellContextMenu, dblclick: _this.props.onCellDoubleClick,
                doubleclick: _this.props.onCellDoubleClick, // this is wrong but either Enzyme or React monkeypatches it in during testing, even when invoked with 'dblclick'
            }[e.type];
            handler === null || handler === void 0 ? void 0 : handler(_this.props.row.data, _this.getCell(), e);
        };
        return _this;
    }
    BodyCell.prototype.componentDidMount = function () {
        if (this.props.reportWidthFn) {
            this.props.reportWidthFn(this.props.col.name, Utils_1.measureWidth(this.domRef.current));
        }
    };
    BodyCell.prototype.getCell = function () {
        return { colIdx: this.props.colIdx, rowIdx: this.props.rowIdx, colKey: this.props.col.dataKey, rowKey: this.props.row.key };
    };
    BodyCell.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d, _e;
        // need to use old context API here because wrapping `cellElement` causes prop forwarding to fail under Tooltip, and converting to a function component costs ~10% perf
        var showColumnHeaders = this.context;
        /* eslint-disable deprecation/deprecation, @typescript-eslint/no-unsafe-assignment */
        var children = this.props.col.cellComponent ? React.createElement(this.props.col.cellComponent, tslib_1.__assign({}, this.props)) :
            (_c = (_b = (_a = this.props.col).cellFormatter) === null || _b === void 0 ? void 0 : _b.call(_a, this.props)) !== null && _c !== void 0 ? _c : React.createElement(DefaultFormatter_1.DefaultFormatter, { value: this.props.value, testId: [this.props.rowIdx, this.props.colIdx, 'Cell'].join('-') });
        /* eslint-enable */
        var cellElement = 
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events -- key events bubble up to DataGrid::handleKeyDown
        React.createElement("div", { "aria-colindex": this.props.colIdx + 1, "aria-rowindex": this.props.rowIdx + (showColumnHeaders ? 2 : 1), "aria-selected": this.props.isSelected, children: children, className: typestyle_1.classes('tb-react-dg-bcell', exports.BodyCellStyleName), "data-tb-test-id": this.props.col.name + BodyCell.CellTestIdSuffix, onContextMenu: this.handleClick, onClick: this.handleClick, onDoubleClick: this.handleClick, style: { height: this.props.height, lineHeight: this.props.height + "px", width: this.props.width }, ref: this.domRef, tabIndex: -1, role: 'gridcell' });
        return React.createElement(widgets_1.Tooltip, tslib_1.__assign({ afterDelay: true, onlyShowWhenClipped: true, position: widgets_1.TooltipPosition.Bottom, getContent: function () { var _a, _b; return !((_a = _this.domRef.current) === null || _a === void 0 ? void 0 : _a.textContent) ? null : React.createElement("span", null, (_b = _this.domRef.current) === null || _b === void 0 ? void 0 : _b.textContent); } }, (_e = (_d = this.props.col).cellTooltip) === null || _e === void 0 ? void 0 : _e.call(_d, this.props), { children: cellElement }));
    };
    BodyCell.displayName = 'DataGridBodyCell';
    return BodyCell;
}(React.PureComponent));
exports.BodyCell = BodyCell;
BodyCell.contextType = Column_1.ColumnHeadersContext;
(function (BodyCell) {
    BodyCell.CellTestIdSuffix = '-cell';
})(BodyCell = exports.BodyCell || (exports.BodyCell = {}));
exports.BodyCell = BodyCell;
//# sourceMappingURL=BodyCell.js.map